import { isPartner } from "../auth";
import MyPagePartner from "../components/mypage/partner";
import MyPageUser from "../components/mypage/user";

export default function MyPage() {
	return <div>{isPartner() ? <MyPagePartner /> : <MyPageUser />}</div>;
}
